import { render } from "./mat-template-edit.vue?vue&type=template&id=74638413&scoped=true"
import script from "./mat-template-edit.vue?vue&type=script&lang=js"
export * from "./mat-template-edit.vue?vue&type=script&lang=js"

import "./mat-template-edit.vue?vue&type=style&index=0&id=74638413&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74638413"]])

export default __exports__